import { DigitalForms } from '@wetags/digital-forms';

/**
 * Feature flag for the enhanced send-forms flow.
 *
 * When enabled, the "Add More Details" step renders the new accordion-based
 * layout. When disabled (default), the original appointment-selection step is
 * shown.
 *
 * Rollout is location-scoped via the `send-forms-enhanced-flow` wetag.
 *
 * NOTE: Once this feature is rolled out to 100%, delete this hook and the old
 * flow it gates, keeping only the enhanced components.
 *
 * @returns a tuple of `[isEnhancedFlowEnabled, isLoading]`
 */
export const useEnhancedSendFormsFlow = (): [boolean, boolean] => {
  const [isEnabled, isLoading] = DigitalForms.useWetag('send-forms-enhanced-flow');
  return [isEnabled, isLoading];
};
